export default function VipTable({ data }) {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="bg-white rounded-xl p-6 shadow border text-gray-400">
        ไม่มีข้อมูลลูกค้า VIP
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow border overflow-x-auto">
      <div className="p-5 border-b">
        <h3 className="font-semibold">รายชื่อลูกค้า VIP</h3>
      </div>

      <table className="w-full text-sm">
        <thead className="bg-gray-50 text-gray-500">
          <tr>
            <th className="px-4 py-3 text-left">ชื่อ</th>
            <th className="px-4 py-3">เพศ</th>
            <th className="px-4 py-3">อายุ</th>
            <th className="px-4 py-3 text-left">ติดต่อ</th>
            <th className="px-4 py-3">สถานะ</th>
            <th className="px-4 py-3">ยอดซื้อ</th>
            <th className="px-4 py-3">คะแนน</th>
            <th className="px-4 py-3">เข้าร้าน</th>
          </tr>
        </thead>

        <tbody>
          {data.map((c, i) => (
            <tr
              key={i}
              className="border-t hover:bg-gray-50 transition"
            >
              <td className="px-4 py-3 flex items-center gap-2">
                <span className="text-yellow-500">👑</span>
                {c.name}
              </td>
              <td className="px-4 py-3 text-center">{c.gender}</td>
              <td className="px-4 py-3 text-center">{c.age} ปี</td>
              <td className="px-4 py-3">
                <div>{c.phone}</div>
                <div className="text-gray-400">{c.email}</div>
              </td>
              <td className="px-4 py-3 text-center">
                <span className="px-2 py-1 rounded-full bg-gray-100 text-xs">
                  VIP
                </span>
              </td>
              <td className="px-4 py-3 text-center">
                ฿{c.totalSpent.toLocaleString()}
              </td>
              <td className="px-4 py-3 text-center">
                {c.points.toLocaleString()}
              </td>
              <td className="px-4 py-3 text-center">
                {c.visits} ครั้ง
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
